function loadImages() {
    const images = require.context('@/assets/players', false, /\.(png|jpe?g|svg)$/);
    const imageMap = {};
  
    images.keys().forEach((key) => {
      const imageName = key.replace('./', ''); 
      const playerId = imageName.split('.')[0];
      imageMap[playerId] = images(key);
    });
  
    return imageMap;
  }
  
  export default loadImages;
  